import { render, staticRenderFns } from "./AuthButton.vue?vue&type=template&id=6848c437&scoped=true"
import script from "./AuthButton.vue?vue&type=script&lang=js"
export * from "./AuthButton.vue?vue&type=script&lang=js"
import style0 from "./AuthButton.vue?vue&type=style&index=0&id=6848c437&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6848c437",
  null
  
)

export default component.exports